import auth from './auth.api'
import main from './main.api'
import guest from './guest.api'
import config from './config.api'
import discounts from './discounts.api'
import parkings from './parkings.api'
import pay from './pay.api'

const Api = {
    Main: main,
    Auth: auth,
    Guest: guest,
    Config: config,
    Discounts: discounts,
    Parkings: parkings,
    Pay: pay
}

export default Api
